// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ui-z","tupacHeader":"Vi-z","tupacHeader2":"Wi-z","tupacMenu":"Xi-z","tupacMenu2":"Yi-z","tupacMain":"Zi-z","tupacMain2":"_i-z"};